<template>
  <div>
    事件
  </div>
</template>

<script>
export default {
  name: "event_edit"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/admin/event_edit.vue